export const AUTH_BROAD_CAST_CHANNEL = {
  root: "auth",
  logOut: "logOut",
  logIn: "logIn",
  tokenUpdate: "tokenUpdate",
};
